import type { Transaction } from '../types'
import { getDisplayText, getDisplayValue } from './display'

/** ยอดที่ถูกจัดสรรแล้วจาก Payment — allocated_amount หรือ legacy slip_matched_amount */
export function resolveSlipMatchedAmount(record: Transaction): number | null {
  const allocated = Number(
    getDisplayValue(record.allocated_amount) ??
      getDisplayValue(record.slip_matched_amount),
  )
  return Number.isFinite(allocated) && allocated >= 0 ? allocated : null
}

export function resolveUnallocatedAmount(record: Transaction): number | null {
  const raw = Number(getDisplayValue(record.unallocated_amount))
  if (Number.isFinite(raw) && raw >= 0) return raw
  const transfer = Number(getDisplayValue(record.transfer_amount))
  const matched = resolveSlipMatchedAmount(record)
  if (!Number.isFinite(transfer) || matched == null) return null
  return Math.max(0, transfer - matched)
}

/** ชื่อลูกค้าฝั่งยอดค้างที่สลิปถูกจับคู่ด้วย */
export function resolveMatchedReceivableCustomer(record: Transaction): string | null {
  const text = getDisplayText(record.matched_receivable_customer).trim()
  return text || null
}
